import React from "react"
import { NavLink } from "react-router-dom"
import { Grid } from "semantic-ui-react"

const TabNavSubNavigation = ({ section, subsections }) => (
  <Grid.Row divided columns="equal" className="TabNav__SubNavigation">
    {subsections.map((subsection, index) =>
      subsection.disabled ? (
        <Grid.Column
          textAlign="center"
          className="TabNav__SubNavigationItem"
          key={index}
        >
          <div className={`TabNav__SubNavigationTitle disabled`}>
            {subsection.title}
          </div>
        </Grid.Column>
      ) : (
        <Grid.Column
          textAlign="center"
          className="TabNav__SubNavigationItem"
          key={index}
        >
          <NavLink
            to={"/" + section.name + "/" + subsection.name}
            activeClassName="TabNav__SubNavigationLink--active"
          >
            <div className={`TabNav__SubNavigationTitle`}>
              {subsection.title}
            </div>
          </NavLink>
        </Grid.Column>
      )
    )}
  </Grid.Row>
)

export default TabNavSubNavigation
